module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header clearfix"
  }, [_c('n3-column', {
    staticClass: "logo-field",
    attrs: {
      "col": 10
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("N3管理系统")])]), _vm._v(" "), _c('n3-column', {
    staticClass: "logout-field"
  }, [_c('n3-tooltip', {
    staticClass: "tip-logout",
    attrs: {
      "content": "登出",
      "placement": "bottom",
      "trigger": "hover"
    }
  }, [_c('n3-icon', {
    attrs: {
      "size": "20px",
      "type": "sign-out"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-401c5466!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/header.vue
// module id = 306
// module chunks = 3